export default __webpack_public_path__ + "static/media/team.805c3ae6.svg";